import { Link } from '@ps/web-shared-components';
import React from 'react';

import type { Category } from '../types';

export const getCategoryTitle = (categories: Category[], currentId: string) =>
  categories?.filter(({ id }) => currentId === id)[0]?.title || '';

export const getSideNavs = (categories: Category[]) =>
  categories?.map(({ id, title }) => ({
    id,
    element: (
      <Link alias="helpCenterCategoryArticles" values={{ category: id }}>
        {title}
      </Link>
    )
  })) || [];
